export const validatePassword = (pwd: string): string[] => {
  const errors: string[] = [];
  if (pwd.length < 8) {
    errors.push('passwordTooShort'); // "Le mot de passe doit comporter au moins 8 caractères."
  }
  if (!/[A-Z]/.test(pwd) || !/[a-z]/.test(pwd)) {
    errors.push('passwordUpperLower'); // "Le mot de passe doit contenir une majuscule et une minuscule."
  }
  if (!/\d|[^A-Za-z0-9]/.test(pwd)) {
    errors.push('passwordNumberOrSpecial'); // "Le mot de passe doit contenir un chiffre ou un caractère spécial."
  }
  return errors;
};
